import React from 'react';
import "./Footer.css";

function Footer() {
    return (
        <div className="Footer">
            <p>Designed by Britanny Chiang and Developed by Subhampreet Mohanty</p>
        </div>
    )
}

export default Footer
